// ***************************************
// Data loading service for checklists
// ***************************************

import { apiClient } from "./apiClient";

// ---------- GET all checklists ----------
export async function fetchChecklists({ workspaceId, token }) {
  return apiClient(`/checklists/workspace/${workspaceId}`, {
    token,
    method: "GET",
  });
}

// ---------- POST create checklist ----------
export async function createChecklist({ token, checklist }) {
  return apiClient(`/checklists`, {
    token,
    method: "POST",
    body: checklist,
  });
}

// ---------- PUT update checklist ----------
export async function updateChecklist({ token, id, checklist }) {
  return apiClient(`/checklists/${id}`, {
    token,
    method: "PUT",
    body: checklist,
  });
}

// ---------- POST archive checklist ----------
export async function archiveChecklist({ token, id, rating, comment }) {
  return apiClient(`/checklists/${id}/archive`, {
    token,
    method: "POST",
    body: { rating, comment },
  });
}

// ---------- DELETE checklist ----------
export async function deleteChecklist({ token, id }) {
  return apiClient(`/checklists/${id}`, {
    token,
    method: "DELETE",
  });
}

// ---------- GET checklist items ----------
export async function fetchChecklistItems({ token, checklistId }) {
  return apiClient(`/checklists/${checklistId}/items`, {
    token,
    method: "GET",
  });
}

// ---------- POST checklist item ----------
export async function createChecklistItem({ token, checklistId, item }) {
  return apiClient(`/checklists/${checklistId}/items`, {
    token,
    method: "POST",
    body: item,
  });
}

// ---------- PUT checklist item ----------
export async function updateChecklistItem({ token, checklistId, itemId, item }) {
  return apiClient(`/checklists/${checklistId}/items/${itemId}`, {
    token,
    method: "PUT",
    body: item,
  });
}

// ---------- DELETE checklist item ----------
export async function deleteChecklistItem({ token, itemId }) {
  return apiClient(`/checklists/items/${itemId}`, {
    token,
    method: "DELETE",
  });
}
